export default "__VITE_ASSET__DErq8Jw5__"